import React from 'react';
/*
import {
  hf,
  hfDTM,
  ht,
  cr,
  a,
  BoxC,
  CbxC,
  IptC,
  LblC,
  GridC,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as IptC from "./_ccbIptC";
import * as GridC from "./_cccGridC";
import * as CbxC from "./_cccCbxC";
import * as LblC from "./_cccLblC";
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as ht from './_ht';
import * as hf from './_hf';

export const N = (pz: {
  sPz: ht.dz,
  boxStlz: ht.dz,
  cz: {
    i1zz: ht.dz,
    i17rs: ht.ls,
    onChgAsync: () => void,
  }
}) => {

//hf.l(`icvI1zS11Co3e 26: here`);
  return (
    cr.c(BoxC.N, {
      key: 'Iccv23b4b.root',
      boxStlz: {
        ... a('dw/f'),
        ... pz.boxStlz
      },
      oClds: [

        cr.c(GridC.N, {
          key: -30,
          abtType: 'nolineCmnz',
          lineCs: [
            {
              boxStlz: a(`dh/8 fd/rac f/n`),
              cellCs: [
                pz.sPz.crt.ctt == 'r' ?
                {
                  boxStlz: a(`f/1 fd/ccc pv/2`),
                  oClds: [
                    cr.c(CbxC.SS, {
                      key: -20,
                      boxStlz: a(`bc/gn7 bw/1 ph/4 pv/2`),
                      cz: {
                        bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                        iptType: 'pcr',
                        vle: pz.cz.i1zz?.i1zrz.i1zrt1100i,
                        onChg: ( _n: ht.n ) => {
                          pz.cz.i1zz.i1zrz.i1zrt1100i = _n;
                        },
                      },
                      lblCz: {
                        textz: {
                          pfx: '優先利用',
                          stlz: a(`tb tc/gn7`),
                        }
                      }
                    })
                  ]
                }
                : null,
                {
                  boxStlz: a(`f/2 fd/css`),
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      abtType: 'hzlStfz',
                      boxStlz: a(`mb/0.5`),
                      lblCz: {
                        abtType: 'hzlStfz',
                        boxStlz: a('dw/10'),
                        textz: {
                          pfx: '目的：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: pz.cz.i1zz?.i1zrz.i1zra4100s,
                              onChg: ( _s: ht.s ) => {
                                pz.cz.i1zz.i1zrz.i1zra4100s = _s;
                              },
                            }
                          })
                        ],
                      },
/*
                      omtCz: 
                        hf.i(pz.sPz.crt.phs, ['crt', 'udt']) ?
                        {
                          abtType: 'omtRqrCmnz',
                        }
                        : null,
*/
                    }),
                    cr.c(LblC.N, {
                      key: -20,
                      abtType: 'hzlStfz',
                      lblCz: {
                        abtType: 'hzlStfz',
                        boxStlz: a('dw/10'),
                        textz: {
                          pfx: '備考：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']),
                              iptType: 'text',
                              vle: pz.cz.i1zz?.i1zrz._ctn,
                              onChg: ( _s: ht.s ) => {
                                pz.cz.i1zz.i1zrz._ctn = _s;
                              },
                            }
                          })
                        ],
                      }
                    }),
                  ]
                },
              ]
            },
          ]
        })

      ]
    })
  );
};
 